import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WhatIsNewService } from '@shared/services/whatIsNew.service';
import { Observable } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as WhatIsNewActions from './what-is-new.actions';
import { select, Store } from '@ngrx/store';
import { selectMlsGroupCode, selectUserId } from '@store/user/user.selector';

@Injectable()
export class WhatIsNewEffects {
  constructor(
    private readonly actions$: Actions,
    // private readonly store$: Store<AppState>,
    private readonly whatIsNewService: WhatIsNewService,
    private readonly store$: Store
  ) {}

  getAnnouncements$: Observable<WhatIsNewActions.GetAnnouncementsSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.GET_ALL_ANNOUNCEMENTS),
      switchMap(() => this.whatIsNewService.getAllAnnouncements()),
      map((payload) => new WhatIsNewActions.GetAnnouncementsSuccess(payload))
    ));

  getAllEnabledAnnouncements: Observable<WhatIsNewActions.GetAllEnabledAnnouncementsSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.GET_ALL_ENABLED_ANNOUNCEMENTS),
      switchMap(() => this.whatIsNewService.getAllEnabledAnnouncements()),
      map((payload) => new WhatIsNewActions.GetAllEnabledAnnouncementsSuccess(payload))
    ));

  getAllAnnouncementsByContentId: Observable<WhatIsNewActions.GetAnnouncementsByContentIdSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.GET_ALL_ANNOUNCEMENTS_BY_CONTENT_ID),
      switchMap((action: WhatIsNewActions.GetAnnouncementsByContentId) => this.whatIsNewService.getAllAnnouncementsByContentId(action.payload)),
      map((payload) => new WhatIsNewActions.GetAnnouncementsByContentIdSuccess(payload))
    ));

  getAllReadAnnouncements: Observable<WhatIsNewActions.GetAllReadAnnouncementsSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.GET_ALL_READ_ANNOUNCEMENTS),
      switchMap((action: WhatIsNewActions.GetAllReadAnnouncements) => this.whatIsNewService.getAllReadAnnouncements(action.payload)),
      map((payload) => new WhatIsNewActions.GetAllReadAnnouncementsSuccess(payload))
    ));

  getAllUnreadAnnouncements: Observable<WhatIsNewActions.GetAllUnreadAnnouncementsSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.GET_ALL_UNREAD_ANNOUNCEMENTS),
      switchMap((action: WhatIsNewActions.GetAllUnreadAnnouncements) => this.whatIsNewService.getAllUnreadAnnouncements(action.payload)),
      map((payload) => new WhatIsNewActions.GetAllUnreadAnnouncementsSuccess(payload))
    ));


  markAsRead: Observable<WhatIsNewActions.MarkAsReadSuccess> = createEffect(() => this.actions$
    .pipe(
      ofType(WhatIsNewActions.MARK_AS_READ),
      withLatestFrom(this.store$.pipe(select(selectUserId)), this.store$.pipe(select(selectMlsGroupCode))),
      switchMap(([action, userId, groupId]: [WhatIsNewActions.MarkAsRead, string, string]) => this.whatIsNewService.markAnnouncementRead({ userId, groupName: groupId, contentId: action.payload.contentId })),
      map((payload) => new WhatIsNewActions.MarkAsReadSuccess(payload))
    ));
}
